// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__PCz1S","location":"Header_location__3qrpg"};